import styled from "styled-components";
import { InsuredDataContainer } from "../../common/insured-styles";

export const ForeignersHealthInsuredContainer = styled(InsuredDataContainer)``;
